import { render, staticRenderFns } from "./LayoutCustomer.vue?vue&type=template&id=02085ffe"
import script from "./LayoutCustomer.vue?vue&type=script&lang=js"
export * from "./LayoutCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02085ffe')) {
      api.createRecord('02085ffe', component.options)
    } else {
      api.reload('02085ffe', component.options)
    }
    module.hot.accept("./LayoutCustomer.vue?vue&type=template&id=02085ffe", function () {
      api.rerender('02085ffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/LayoutCustomer.vue"
export default component.exports